var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m452 330c-11.046 0-20-8.954-20-20v-163c0-44.112-35.888-80-80-80h-192c-44.112 0-80 35.888-80 80v163c0 11.046-8.954 20-20 20s-20-8.954-20-20v-163c0-66.168 53.832-120 120-120h192c66.168 0 120 53.832 120 120v163c0 11.046-8.954 20-20 20zm60 95c0-33.084-26.916-60-60-60h-392c-33.084 0-60 26.916-60 60s26.916 60 60 60h392c33.084 0 60-26.916 60-60zm-60-20c11.028 0 20 8.972 20 20s-8.972 20-20 20h-392c-11.028 0-20-8.972-20-20s8.972-20 20-20zm-129-245c0-34.738-28.262-63-63-63s-63 28.262-63 63 28.262 63 63 63 63-28.262 63-63zm-40 0c0 12.682-10.317 23-23 23s-23-10.318-23-23 10.317-23 23-23 23 10.318 23 23zm43.128 169.353c10.688-2.788 17.093-13.712 14.305-24.4-9.207-35.3-41.216-59.953-77.839-59.953h-11.188c-36.623 0-68.632 24.653-77.839 59.952-2.788 10.688 3.616 21.612 14.305 24.4 10.692 2.787 21.611-3.616 24.4-14.305 4.615-17.691 20.707-30.047 39.134-30.047h11.188c18.427 0 34.52 12.356 39.134 30.048 2.347 8.996 10.457 14.957 19.339 14.957 1.67 0 3.369-.211 5.061-.652z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.54339cab5c2d5b95b85db1374eea1863.svg";
export { ForwardRef as ReactComponent };